import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { UserService } from './../../services/user.service';
import { SLAKPIApiService } from './../../services/slakpi.service';
import { kpiNotification } from './../../models/slakpi';
declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {
  // custom code end
  public KPINotification_data: any = [];
  public user: any = {};
  isAdmin: boolean = false;
  public login_UserID: string; // number
   
  nitifyCount: number = 0; public isBMChambion: boolean = false;
  public isBMAdmin: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;


  constructor(private userService: UserService, public restApi: SLAKPIApiService, public router: Router) {
    //code
  }
  ngOnInit() {
    this.userService.CheckLogin();
    this.user = this.userService.getUserInfo();
    
    this.login_UserID = this.user.id; 
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    if (this.user.role == 'BM Champions')
      this.isBMChambion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }
    this.loadKPINotification();
    //let sl: any = $('.slider');
    //sl.slider();
 
  }

  loadKPINotification() {
    
    let inpValue = new kpiNotification();
    //inpValue.condition = 2;
    if (this.isBMChambion || this.isBMVisitor || this.isBMTeam || this.isBMAdmin) {
      inpValue.condition = 5;
    } else { inpValue.condition = 2; }
    inpValue.tenantUno = 1;
    inpValue.notifyUno = 0;
    inpValue.userUno = this.login_UserID;
    this.KPINotification_data = [];
    this.restApi.getKPINotification(inpValue)
      .subscribe(data => {
        
        let rtnData: any = data;
        if (rtnData.data.length > 0) {
          this.KPINotification_data = rtnData.data;
          
          this.nitifyCount = this.KPINotification_data.length;
          if (this.nitifyCount > 0) {
            
           // let ntfyCount: any = document.getElementById("ntfyCount");
           // ntfyCount.style.display = "inline";
           // ntfyCount.innerText = this.nitifyCount.toString(); 

          }
        }

      },
        (error) => {
          //Called when error
          //  this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        // this.spinner.hide();
      });
  }

  submitNotifyAction(pageType: any, kpiTrnUno: any, notifyUno: any) {
    if (pageType == 'inbox') {
      if (kpiTrnUno > 0) {
        this.router.navigateByUrl('/kpiview/' + kpiTrnUno);
      }
      else {
        this.router.navigateByUrl('/inbox/dataentry');
      }
    }

  }

}
